module.exports = __webpack_public_path__ + "static/media/plymouthLogo.1d488a07.png";